import { validDomain } from '@/contants';
import { getVersion } from '../utils'
import * as types from './types'
import * as services from '../services/user'
import * as activityServices from '../services/activity'
import { createPoster } from '../utils/combinePoster'
import _app from '../main'
import { jumpToApp, copyAction, setShare } from '@/utils/hybrid'

export default {
  /**
   * 获取设备信息
   */
  getDeviceInfo ({ commit }) {
    const version = getVersion()
    commit(types.SET_VERSION, version)
  },
  /**
   * 获取用户配置信息
   */
  async getUserConfig ({ dispatch, getters, commit}, payload = {}) {
    if (!getters.isApp) {
      const { pid = void 0, relationId = void 0} = payload
      commit(types.SET_USER_CONFIG, { pid, relationId})
    } else {
      console.log('payload', payload)
      await dispatch('getRelationId', {scene: payload.scene || 'activity'})
    }
  },
  /**
   * 获取用户relationId和pid
   */
  async getRelationId ({commit, dispatch}, payload) {
    const res = await services.getRelationId(payload)
    if (res.data.relationId) {
      commit(types.SET_USER_CONFIG, res.data)
    } else {
      await dispatch('getUserInfo')
      await dispatch('getUserPid')
    }
  },
  /**
   * 获取用户信息
   */
  async getUserInfo ({commit}) {
    const res = await services.getUserInfo()
    commit(types.SET_USER_CONFIG, res.data)
    return res.data
  },
  /**
   * 根据用户的agentId获取pid
   */
  async getUserPid ({state, commit}) {
    const res = await services.getUserPid({agentId: state.userInfo.agentId})
    if (!res.data.pid) {
      _app.$toast.show('您需要先进行代理授权才能参与此活动')
      setTimeout(() => {
        window.location.href = 'http://m.xuanwonainiu.com/static/yh/auth/'
      })
    } else {
      commit(types.SET_USER_CONFIG, {pid: res.data.pid})
    }
  },
  /**
   * 获取分享域名
   */
  async getShareDomain ({ commit }) {
    const domains = validDomain;
    if (domains.length > 0) {
      let randomId = Math.floor(Math.random() * domains.length)
      commit(types.SET_SHARE_DOMAIN, domains[randomId])
    }
  },
  /**
   * 拼接海报图
   */
  async combinePoster ({ state, commit, getters }) {
    if (state.activityConfig && state.activityConfig.posterBgImg) {
      const params = {
        ...state.activityConfig,
        qrText: getters.shareUrl,
        isAndroid: getters.isAndroid
      }
      const imgUrl = await createPoster(params)
      commit(types.SET_ACTIVITY_CONFIG, {shareImgUrl: imgUrl})
    }
  },
  /**
   * 根据活动id获取pwd及跳转链接
   * activityId: 活动id
   * title: 活动名称
   * imageUrl: 复制淘口令后在淘宝打开的弹窗图
   */
  async getActivityPwd ({state}, payload) {
    const { relationId, pid } = state.userInfo
    const params = {
      relationId,
      pid,
      activityId: payload.activityId,
      title: payload.title || '悦惠活动专属',
      imageUrl: payload.imageUrl || '//xwstatic.js571.com/%E7%BC%A9%E7%95%A5%E5%9B%BE.jpg?imageView2/0/w/750/h/275/format/webp/interlace/1'
    }
    const res = await activityServices.getActivityPwd(params)
    return res.data
  },
  /**
   * 跳转到其他APP（淘宝：1、京东:2、拼多多:10）
   * url: 跳转链接
   * sourcePlatType： 默认1，即淘宝
   */
  handleJumpAction ({getters}, payload) {
    const { url, sourcePlatType = 1 } = payload
    const { isIOS, isWeixin, isApp } = getters
    if (url) {
      if (isIOS) {
        jumpToApp({
          url,
          sourcePlatType
        })
      } else if (!isWeixin){
        if (isApp) {
          try {
            jumpToApp({
              url,
              sourcePlatType
            })
          } catch (e) {
            console.log(e);
            window.location.href = url
          }
        } else {
          window.location.href = url
        }
      }
    }
  },
  /**
   * 复制
   * copyText: 需要复制的文字
   * sucText: 复制成功后的提示
   * errText: 复制失败后的提示
   */
  handleCopyAction ({getters}, payload) {
    const {
      copyText,
      sucText = '复制成功，请打开手机淘宝!',
      errText = '复制失败，请长按选择进行复制!'
    } = payload
    const { isApp } = getters
    if (copyText) {
      if (isApp) {
        copyAction({
          text: copyText
        })
      } else {
        _app.$copyText(copyText).then(() => {
          _app.$toast.show(sucText)
        }, err => {
          console.log(err)
          _app.$toast.show(errText)
        })
      }
    }
  },
  /**
   * 分享图片
   * shareImgUrl: 图片src
   * copyText: 若存在，在APP里调用copyAction
   * showModal: 若存在，在非APP里弹出海报弹窗
   */
  handleShareAction ({getters, commit}, payload) {
    const { shareImgUrl, copyText, showModal } = payload
    const { isApp } = getters
    if (shareImgUrl) {
      if (isApp) {
        setShare({
          imgUrls: [shareImgUrl]
        })
        if (copyText) {
          copyAction({
            text: copyText
          })
        }
      } else {
        if (showModal) {
          commit('showPosterModal')
        }
      }
    }
  },
  // 获取特价版信息
  async getTjbRes ({commit}, payload) {
    const res = await services.getTjb(payload)
    commit(types.SET_TJB_CONFIG, res.data);
    return res.data
  },
  // 获取1元购配置
  async getYyg ({_}, payload) {
    const res = await services.getYyg(payload)
    console.log(_)
    return res.data
  },

  // 获取1元购配置
  async getCommonAct ({_}, payload) {
    const { pid, relationId, actId } = payload;
    const res = await activityServices.getCommonAct({
      pid, relationId, actId
    })
    console.log(_)
    return res.data
  },
}
